import { Stub } from "@components/atoms/Stub"
import { ChipButton } from "@components/controls/Button"
import { defineBlock, EditableText, usePostEditor, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Event Details and Tickets",
  tags: ["root"],
  conditions: {
    postTypes: ["event"],
    multiple: false,
  },
  postMetaBlock: {
    postTypes: ["event"],
    fieldName: "eventInfo2",
  },
}

export default defineBlock("events/event-editor-details", (props) => {
  return (
    <div className="stack-y-2">
      <Stub>Date, location and tickets will appear here</Stub>
    </div>
  )
})
